













import Vue from 'vue';
import CvSectionTextForm, {
  FormDataInterface,
} from '@/containers/cv-section-text/form.vue';
import * as CvStore from '@/containers/cv/store';
import * as CvSectionTextStoreNew from '@/store/modules/cvSectionTextNew';
import { i18n, i18nHints } from '@/plugins/i18n';

export default Vue.extend({
  components: {
    CvSectionTextForm,
  },
  data() {
    return {
      section: {
        title: null,
        content: null,
      } as FormDataInterface,
    };
  },
  methods: {
    async onSubmit({ title, content }: FormDataInterface) {
      const { cv_id } = this.$route.params;
      await this.$store.dispatch(
        CvSectionTextStoreNew.CreateCvSectionText.namespaced({
          params: {
            cv_id,
          },
          body: {
            title,
            content,
          },
        })
      );
      this.$notifySuccess(i18n.tc(i18nHints.common.notification.created));
      // refresh sections
      this.$store.dispatch(CvStore.GetCvCvSections.namespaced({ cv_id }));
      this.$router.push({ name: 'cv_edit_path' });
    },
    onCancel() {
      this.$backOrGoTo({ name: 'cv_edit_path' });
    },
  },
});
